<template>
  <div class="qualitychecktest-panel">
    <v-card class="mx-auto " >
      <div class="d-flex flex-column justify-space-between align-center">
        <v-img
          class = "ma-2 "
          max-height="250"
          max-width="250"
          lazy-src="@/assets/imagenotfound.png"
          :key="componentKey"
          :src="imageurlItem"
        >
        </v-img>
        <v-card-title>
          <span v-if="locale == 'fr' & item['namefr'] != ''">{{ item['namefr'] }}</span>
          <span v-else>{{ item['name'] }}</span>
        </v-card-title>
        <v-card-subtitle>
          <span v-if="locale == 'fr' & item['issuefr'] != ''">{{ item['issuefr'] }}</span>
          <span v-else>{{ item['issue'] }}</span>
        </v-card-subtitle>
      </div>
        <v-card-actions>
          <v-btn color="primary" text>
            {{$t('global.explore')}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="detailShow = !detailShow">
            <v-icon>{{ detailShow ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-btn>
        </v-card-actions>
        <v-expand-transition>
          <div v-show="detailShow">
            <v-divider></v-divider>
            <v-card-text>
              <span v-if="locale == 'fr' & item['commentfr'] != ''">{{ item['commentfr'] }}</span>
              <span v-else>{{ item['comment'] }}</span>
            </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>
  </div>
</template>

<script>
import FileMixin from '../../mixins/FileMixin';
import i18n from '../../i18n.js';
const servicePrefix = 'QualityCheckTest';

export default {
  name: 'QualityCheckTestPanel',
  servicePrefix,
  mixins: [FileMixin],
  components: {

  },
  props: {
    values: {
      type: Object,
      required: true
    },
    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      filter: '',
      detailShow: false,
    };
  },

  computed: {
    item() {
      return this.initialValues || this.values;
    },
    locale() {
      return i18n.locale;
    },
  },
  methods: {

  }
};
</script>
